import useAxios from "./useAxios";
import service from './service';
export default {
  install(Vue) {
    Vue.use(useAxios, service);
  }
}


// WEBPACK FOOTER //
// ./src/common/request/index.js